<div class="content-wrapper">

  <!-- Contenido principal con los carruseles -->
  <main class="content">
  <!-- New section for random story -->
  <div class="random-story-section">
    <h2>{{ translationService.getTranslation('Descubre una nueva historia') }}</h2>
    <button (click)="discoverRandomStory()" class="random-story-btn">
      {{ translationService.getTranslation('Descubrir') }}
    </button>
  </div>
    <div *ngIf="isAuthenticated">  <!-- Este if quita esta seccion si no esta autenticado -->
      <h2>{{ translationService.getTranslation('Noticias') }}</h2>
      <a href="" class="mpc-sec-view">
        {{ translationService.getTranslation('Ver mas') }} &#10095;
      </a>
    
      <div class="carousel-container">
        <button class="carousel-btn prev-btn" (click)="prevCarousel('noticias')">&#10094;</button>
        <div class="carousel-track" id="noticias">
          <div *ngFor="let episode of episodes" class="carousel-item episode-card">
            <img [src]="episode.img" alt="Episodio">
            <h3>{{ episode.title }}</h3>
            <p>{{ episode.author }}</p>
            <p>{{ episode.views }}</p>
          </div>
        </div>
        <button class="carousel-btn next-btn" (click)="nextCarousel('noticias')">&#10095;</button>
      </div>
    </div>
    
    <div *ngIf="isMobile">
      <h2>{{ translationService.getTranslation('Recomendados') }}</h2>
      <a href="" class="mpc-sec-view">
        {{ translationService.getTranslation('Ver mas') }} &#10095;</a>
    </div>
   
    <div class="carousel-container" *ngIf="isMobile">
      <button class="carousel-btn prev-btn" (click)="prevCarousel('recomendados')">&#10094;</button>
      <div class="carousel-track" id="recomendados">
        <div *ngFor="let episode of episodes" class="carousel-item episode-card">
          <img [src]="episode.img" alt="Episodio 1">
          <h3>{{ episode.title }}</h3>
          <p>{{ episode.author }}</p>
          <p>{{ episode.views }}</p>
        </div>
      </div>
      <button class="carousel-btn next-btn" (click)="nextCarousel('recomendados')">&#10095;</button>
    </div>

    <div>
      <h2>{{ translationService.getTranslation('Nuevos episodios') }}</h2>
      <a href="" class="mpc-sec-view">
        {{ translationService.getTranslation('Ver mas') }} &#10095;</a>
    </div>
   
    <div class="carousel-container">
      <button class="carousel-btn prev-btn" (click)="prevCarousel('nuevos-episodios')">&#10094;</button>
      <div class="carousel-track" id="nuevos-episodios">
        <div *ngFor="let episode of episodes" class="carousel-item episode-card">
          <img [src]="episode.img" alt="Episodio 1">
          <h3>{{ episode.title }}</h3>
          <p>{{ episode.author }}</p>
          <p>{{ episode.views }}</p>
        </div>
      </div>
      <button class="carousel-btn next-btn" (click)="nextCarousel('nuevos-episodios')">&#10095;</button>
    </div>

    <div>
      <h2>{{ translationService.getTranslation('Nuevas obras subidas') }}</h2>
      <a href="" class="mpc-sec-view">
        {{ translationService.getTranslation('Ver mas') }} &#10095;</a>
    </div>
    
    <div class="carousel-container">
      <button class="carousel-btn prev-btn" (click)="prevCarousel('artworks')">&#10094;</button>
      <div class="carousel-track" id="artworks">
        <div *ngFor="let artwork of artworks" class="carousel-item artwork-card">
          <img [src]="artwork.img" alt="Obra 1">
          <h3>{{ artwork.title }}</h3>
          <p>{{ artwork.author }}</p>
          <p>{{ artwork.views }}</p>
        </div>
      </div>
      <button class="carousel-btn next-btn" (click)="nextCarousel('artworks')">&#10095;</button>
    </div>
  </main>

  <!-- Sidebar -->
  <aside class="sidebar desktop-only">
    <h3>{{ translationService.getTranslation('Obras populares') }}</h3>
    <ul>
      <div *ngFor="let item of sidebarItems" class="artwork-card">
        <img [src]="item.img" alt="Obra 100">
        <h3>{{ item.title }}</h3>
        <p>{{ item.author }}</p>
        <p>{{ item.views }}</p>
      </div>
    </ul>
  </aside>
</div>

